export default class DtoUserBookmark {
    constructor(obj) {
        this.login = obj.login
        this.identifiant = obj.identifiant
        this.stationType = obj.stationType
    }
}